import React from 'react';
import { Route, Switch } from 'react-router-dom';

//components
import CategoryPage from '../category-page/cat-page';
import ItemPage from '../item-page/item-page';
import SearchPage from '../search-page/search-page';
import WishlistPage from '../wishlist-page/WishlistPage';
import RentalByLocationPage from '../rental-by-location-page/RentalByLocationPage';

const RentalPage = ({ match }) => {
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={RentalByLocationPage } />
      <Route path={`${match.path}/search`} component={SearchPage} />
      <Route path={`${match.path}/wishlist`} component={WishlistPage} />
      <Route path={`${match.path}/categories/:category`} component={CategoryPage}/>
      <Route path={`${match.path}/:rentalId`} component={ItemPage} />
    </Switch>
  );
};

export default RentalPage;